// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Aq3x","productName":"Table_productName__1iNtL"};